// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3JRpA","bigColWidth":"Table_bigColWidth__jqoN1","biggerColWidth":"Table_biggerColWidth__UXURN","row":"Table_row__sGKh0","col":"Table_col__1pI_W"};